
let $flowStatus = new Map();
//-1.已终止，0未开始 1.待配置，2.待领取，3.进行中，4.已完成
$flowStatus.set(-1, "已取消");
$flowStatus.set(0, "未开始");
$flowStatus.set(1, "待配置");
$flowStatus.set(2, "待领取");
$flowStatus.set(3, "进行中");
$flowStatus.set(4, "已完成");
$flowStatus.set(-4, "风控还原");
$flowStatus.set(-3, "待风控确认");
$flowStatus.set(-2, "暂停");

let $flowTaskStatus = new Map();
//质控任务状态：-1 已取消 1待领取 2进行中 3已提交
$flowTaskStatus.set(-1, "已取消");
$flowTaskStatus.set(1, "待领取");
$flowTaskStatus.set(2, "进行中");
$flowTaskStatus.set(3, "已提交");

let $flowType = new Map();
//1.机翻，2.打标，4.PE，6.质控
$flowType.set(1, "机翻");
$flowType.set(2, "打标");
$flowType.set(3, "PE");
$flowType.set(4, "审核");
$flowType.set(5, "PE&审核");
$flowType.set(6, "质控");
$flowType.set(7, "新增术语及审核");
$flowType.set(8, "实际活动成本");
$flowType.set(9, "预计活动成本");


let $actionType = new Map();
// 1 一次打标 2 二次打标 3 PE,4 PE审核
$actionType.set(1, "一次打标");
$actionType.set(2, "二次打标");
$actionType.set(3, "PE");
$actionType.set(4, "PE审核");


let $costType = new Map();
// 1 机翻 2 一次打标 3 二次打标  4 PE 5 PE审核 6 质控
$costType.set(1, "机翻");
$costType.set(2, "一次打标");
$costType.set(3, "二次打标");
$costType.set(4, "PE");
$costType.set(5, "PE审核");
$costType.set(6, "质控");
$costType.set(7, "新增术语及审核");
$costType.set(8, "实际活动成本");
$costType.set(9, "预计活动成本");



let $taskStatus = new Map();
//-5被质控打回任务池 -4已放弃 -3.被打回任务池， -2.已取消，-1.超时放弃，1.待领取，2.待提交，3,PE待修改，4，PE已提交，5.PE审核打回任务池， 6.PE审核打回修改 ，7.已完成
$taskStatus.set(-5, "被质控打回任务池");
$taskStatus.set(-4, "已放弃");
$taskStatus.set(-3, "被审核打回任务池");
$taskStatus.set(-2, "已取消");
$taskStatus.set(-1, "超时放弃");
$taskStatus.set(0, "PE审核打回修改");
$taskStatus.set(1, "待领取");
$taskStatus.set(2, "待提交");
$taskStatus.set(3, "PE待修改");
$taskStatus.set(4, "PE已提交");
$taskStatus.set(5, "PE审核打回任务池");
$taskStatus.set(6, "PE审核打回修改");
$taskStatus.set(7, "已完成");



let $markResult = new Map();
//1.未打标，2.无需修改，3.轻度修改，4.中度修改 5重度修改
$markResult.set(1, "未打标");
$markResult.set(2, "无需修改");
$markResult.set(3, "轻度修改");
$markResult.set(4, "中度修改");
$markResult.set(5, "重度修改");

let $auditResult = new Map();
//1=待审核、2=审核通过、0=待修改、3=打回修改、4=审核修改、-3=被审核打回任务池、-4=已放弃、-1=超时放弃、-2=已取消、5=打回任务池、-5=被质控打回任务池、6=自动通过
$auditResult.set(0, "待修改");
$auditResult.set(1, "待审核");
$auditResult.set(2, "审核通过");
$auditResult.set(3, "打回修改");
$auditResult.set(4, '质控修改');
$auditResult.set(5, "打回任务池");
$auditResult.set(6, "自动通过");
$auditResult.set(-1, "超时放弃");
$auditResult.set(-2, "已取消");
$auditResult.set(-3, "被审核打回任务池");
$auditResult.set(-4, "已放弃");
$auditResult.set(-5, "被质控打回任务池");

let $fileSource = new Map();
//1.原稿，2.机翻还原稿，3.机翻平行语料稿，4.PE还原稿 5PE平行语料表 6质控搞 7聚合文件
$fileSource.set(1, "原稿");
$fileSource.set(2, "机翻还原稿");
$fileSource.set(3, "机翻平行语料稿");
$fileSource.set(4, "PE还原稿");
$fileSource.set(5, "PE平行语料表");
$fileSource.set(6, "质控搞");
$fileSource.set(7, "聚合文件");


let $riskLevel = new Map();
$riskLevel.set(0, "风险0级");
$riskLevel.set(1, "风险1级");
$riskLevel.set(2, "风险2级");
$riskLevel.set(3, "风险3级");
$riskLevel.set(9, "需要翻译");


let $qcResult = new Map();
$qcResult.set(-1, "待处理");
//4 打回任务池 1 未处理 2 已修改 3 已阅无误
$qcResult.set(1, "未处理");
$qcResult.set(2, "已修改");
$qcResult.set(3, "已阅无误");
$qcResult.set(4, "打回任务池");

let $sysLan = new Map();
$sysLan.set('zh-CN',"简体中文");
$sysLan.set('it',"意大利语");
$sysLan.set('es',"西班牙语");
$sysLan.set('pt',"葡萄牙语");
$sysLan.set('ar',"阿拉伯语");
$sysLan.set('tr',"土耳其语");
$sysLan.set('ug',"维吾尔语");
$sysLan.set('fa',"波斯语");
$sysLan.set('mn',"蒙古语");
$sysLan.set('id',"印尼语");
$sysLan.set('ms',"马来语");
$sysLan.set('en',"英语");
$sysLan.set('th',"泰语");
$sysLan.set('vi',"越南语");
$sysLan.set('lo',"老挝语");
$sysLan.set('hi',"印度语");
$sysLan.set('bn',"孟加拉语");
$sysLan.set('km',"柬埔寨语");
$sysLan.set('ne',"尼泊尔语");
$sysLan.set('uk',"乌克兰语");
$sysLan.set('da',"丹麦语");
$sysLan.set('no',"挪威语");
$sysLan.set('ja',"日语");
$sysLan.set('fi',"芬兰语");
$sysLan.set('el',"希腊语");
$sysLan.set('pl',"波兰语");
$sysLan.set('ro',"罗马尼亚语");
$sysLan.set('bg',"保加利亚语");
$sysLan.set('cs',"捷克语");
$sysLan.set('sk',"斯洛伐克语");
$sysLan.set('hu',"匈牙利语");
$sysLan.set('la',"拉丁语");
$sysLan.set('he',"希伯莱语");
$sysLan.set('fr',"法语");
$sysLan.set('yi',"依地语");
$sysLan.set('sv',"瑞典语");
$sysLan.set('hr',"克罗地亚语");
$sysLan.set('sq',"阿尔巴尼亚");
$sysLan.set('my',"缅甸语");
$sysLan.set('tl',"塔路加族语");
$sysLan.set('kk',"哈萨克斯坦语");
$sysLan.set('de',"德语");
$sysLan.set('so',"索马里语");
$sysLan.set('sr',"塞尔维亚语");
$sysLan.set('uz',"乌兹别克斯坦语");
$sysLan.set('sl',"斯洛文尼亚语");
$sysLan.set('af',"南非荷兰语");
$sysLan.set('ru',"俄语");
$sysLan.set('be',"比利时语");
$sysLan.set('tn',"泰米尔语");
$sysLan.set('hindi',"印地语");
$sysLan.set('br',"葡萄牙语(巴西)");
$sysLan.set('yqy02',"泰卢固语");
$sysLan.set('yqy03',"旁遮普语");
$sysLan.set('yqy04',"马拉地语");
$sysLan.set('yqy05',"马拉雅拉姆语");
$sysLan.set('ko',"韩语");
$sysLan.set('yqy06',"吉吉拉特语");
$sysLan.set('yqy08',"爪哇语");
$sysLan.set('yqy09',"菲律宾语");
$sysLan.set('zh-HK',"繁体中文(香港)");
$sysLan.set('zh-TW',"繁体中文(台湾)");
$sysLan.set('other',"其它");
$sysLan.set('nl',"荷兰语");

export {
  $flowStatus,
  $flowType,
  $actionType,
  $sysLan,
  $taskStatus,
  $markResult,
  $auditResult,
  $fileSource,
  $qcResult,
  $costType,
  $riskLevel,
  $flowTaskStatus
}

